import {Component, inject, Input, OnDestroy, OnInit} from '@angular/core';
import {ApiBaseService, VendorsService} from '../../../../../../projects/vendors/src/public-api';
import {ApiEnum} from '../../../../@application/enum/api.enum';
import {OrderType} from '../../../../@application/enum/order-type.enums';
import {Subscription} from "rxjs";

@Component({
    selector: 'app-operational-details',
    templateUrl: './operational-details.component.html',
    styleUrl: './operational-details.component.scss',
    standalone: false
})
export class OperationalDetailsComponent implements OnInit, OnDestroy {

  operationalDetails: any[] = []
  totalProfit = 0
  @Input() role!: string
  totalRevenue = 0
  numberofOrders = 0
  apiBaseService = inject(ApiBaseService);
  vendorsService = inject(VendorsService);
  orderType = OrderType
  newOrderSubscription!: Subscription;
  orderCloseSubscription!: Subscription;
  orderStatusSubscription!: Subscription;

  ngOnInit(): void {
    this.dataSubscriptions()
    this.getData();
  }

  private dataSubscriptions() {
    this.newOrderSubscription = this.vendorsService.newOrderSubject.subscribe({
      next: newOrder => {
        if (newOrder)
          this.getData();
      }
    })
    this.orderCloseSubscription = this.vendorsService.orderCloseSubject.subscribe({
      next: orderClose => {
        if (orderClose)
          this.getData();
      }
    })
    this.orderStatusSubscription = this.vendorsService.orderStatusSubject.subscribe({
      next: orderStatus => {
        if (orderStatus)
          this.getData();
      }
    })
  }


  private getData() {
    this.apiBaseService.GET<any[]>([ApiEnum.RestaurantModule, ApiEnum.OrderBill, ApiEnum.DashBoard, ApiEnum.RevenueProfit])
      .subscribe({
        next: response => {
          this.numberofOrders = response.reduce((sum, item) => sum + item.totalOrders, 0);
          this.totalRevenue = response.reduce((sum, item) => sum + item.totalRevenue, 0);
          this.totalProfit = response.reduce((sum, item) => sum + item.totalProfit, 0);
          this.operationalDetails = response;
        }
      })
  }


  ngOnDestroy(): void {
    this.newOrderSubscription.unsubscribe();
    this.orderCloseSubscription.unsubscribe();
    this.orderStatusSubscription.unsubscribe();
  }

}
